import styled from 'styled-components';

import { Searcher } from 'components/modules/Insurance/Insurance.styles';

import { NAME } from './BankSearcher.constants';

export const ModelSearcher = styled(Searcher).attrs({ label: 'Банк кредитор', name: NAME })``;
